var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gocc"},[_c('van-popup',{attrs:{"close-on-click-overlay":false,"round":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('img',{attrs:{"src":require("@/assets/images/Customer-service-waiting.gif"),"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }